import React from "react";
import { Button, DialogActions, TextField } from "@mui/material";
import { useFormik } from "formik";
import { validationSchemaDealer } from "./ValidationSchema";
const AddDealer = (props) => {
  const { prevStep, Values, handleSubmit } = props;

  const formik = useFormik({
    initialValues: {
      dealerName: Values.dealerName,
      dealerAddress: Values.dealerAddress,
      dealerEmail: Values.dealerEmail,
      dealerContact: Values.dealerContact,
    },
    validationSchema: validationSchemaDealer,
    onSubmit: (values) => {
      // update Values state with formik values
      for (const key in values) {
        Values[key] = values[key];
      }
      // call handleSubmit function from parent component
      handleSubmit();
    },
  });

  return (
    <>
      <div>
        <form onSubmit={formik.handleSubmit}>
          <div className="grid grid-cols-1 gap-4 p-2">
            <TextField
              type="text"
              fullWidth
              id="dealerName"
              label="Dealer Name"
              value={formik.values.dealerName}
              onChange={formik.handleChange}
              error={
                formik.touched.dealerName && Boolean(formik.errors.dealerName)
              }
              helperText={formik.touched.dealerName && formik.errors.dealerName}
            />
            <TextField
              type="text"
              fullWidth
              id="dealerAddress"
              label="Dealer Address"
              value={formik.values.dealerAddress}
              onChange={formik.handleChange}
              error={
                formik.touched.dealerAddress &&
                Boolean(formik.errors.dealerAddress)
              }
              helperText={
                formik.touched.dealerAddress && formik.errors.dealerAddress
              }
            />
            <TextField
              type="text"
              fullWidth
              id="dealerEmail"
              label="Dealer Email"
              value={formik.values.dealerEmail}
              onChange={formik.handleChange}
              error={
                formik.touched.dealerEmail && Boolean(formik.errors.dealerEmail)
              }
              helperText={
                formik.touched.dealerEmail && formik.errors.dealerEmail
              }
            />
            <TextField
              type="text"
              fullWidth
              id="dealerContact"
              label="Dealer Contact"
              value={formik.values.dealerContact}
              onChange={formik.handleChange}
              error={
                formik.touched.dealerContact &&
                Boolean(formik.errors.dealerContact)
              }
              helperText={
                formik.touched.dealerContact && formik.errors.dealerContact
              }
            />
            <DialogActions>
              <div className="flex gap-2 justify-end">
                <Button
                  className="bg-[#3671D5] hover:bg-[#114AAA] text-white"
                  type="button"
                  onClick={prevStep}
                >
                  Back
                </Button>
                <Button
                  className="bg-[#3671D5] hover:bg-[#114AAA] text-white"
                  type="submit"
                >
                  Next
                </Button>
              </div>
            </DialogActions>
          </div>
        </form>
      </div>
    </>
  );
};

export default AddDealer;
